// extracted by mini-css-extract-plugin
export default {"row":"PropertiesTab_row__xusJR"};